import { type FixedTermMarketPathParams, getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

const fixedTermMarketQueryKey = ['fixedTermMarket'] as const

export const fixedTermMarketQueryOptions = ({ network, vaultId }: FixedTermMarketPathParams) =>
  queryOptions({
    queryKey: [...fixedTermMarketQueryKey, { network, vaultId }] as const,
    async queryFn() {
      const internalAppSdk = getInternalAppSdk()
      return await internalAppSdk.getFixedTermMarket({ network, vaultId })
    },
    retry: 2,
    staleTime: 30 * MINUTE_IN_MILLISECONDS,
    refetchInterval: 30 * MINUTE_IN_MILLISECONDS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })

interface UseFixedTermMarketQueryParams extends FixedTermMarketPathParams {
  initialData?: ReturnType<typeof fixedTermMarketQueryOptions>['initialData']
}

export const useFixedTermMarketQuery = ({ initialData, ...params }: UseFixedTermMarketQueryParams) => {
  const { data, isFetching } = useQuery({
    ...fixedTermMarketQueryOptions(params),
    initialData,
  })

  return { data, isFetching }
}
